import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs';
import { PhoneNumberAction } from '../actions';
import { MetadataApiService } from '@cms/apis';

@Injectable()
export class PhoneNumberEffects {
  countries$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PhoneNumberAction.onCountriesLoading),
      mergeMap(() => this.metadataService.getCountryPhoneNumber().pipe(map(data => PhoneNumberAction.countriesLoaded({ payload: data }))))
    );
  });
  constructor(private actions$: Actions, private metadataService: MetadataApiService) {}
}
